import { render, staticRenderFns } from "./HomeCarouselFrame.vue?vue&type=template&id=5867220d&scoped=true&"
import script from "./HomeCarouselFrame.vue?vue&type=script&lang=ts&"
export * from "./HomeCarouselFrame.vue?vue&type=script&lang=ts&"
import style0 from "./HomeCarouselFrame.vue?vue&type=style&index=0&id=5867220d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867220d",
  null
  
)

export default component.exports